<template>
  <div class="open-invoice-add open-invoice open-invoice-details">
    <div class="open-invoice-flex">
      <div class="invoice-row row-box">
        <div class="invoice-row-name">电子发票</div>
        <div class="invoice-row-flex" @click="getStatusInfo">
          {{ detailsInfo.applyStatusDesc }}
        </div>
        <div
          class=""
          v-if="
            (detailsInfo.applyStatus == 3 && detailsInfo.invoiceSerialNum) ||
            detailsInfo.applyStatus == 2
          "
        >
          <img
            class="right-icon"
            src="../../assets/img/icon-right.png"
            alt=""
          />
        </div>
      </div>
      <div class="invoice-details">
        <div class="invoice-info">
          <div class="invoice-row">
            <div class="invoice-row-name">抬头类型</div>
            <div class="invoice-row-flex">
              {{ detailsInfo.invoiceTypeDesc }}
            </div>
          </div>
          <div class="invoice-row">
            <div class="invoice-row-name">发票抬头</div>
            <div class="invoice-row-flex">
              {{ detailsInfo.invoiceTitleTypeDesc }}
            </div>
          </div>
          <div class="invoice-row" v-if="detailsInfo.invoiceSerialNum">
            <div class="invoice-row-name">发票流水号</div>
            <div class="invoice-row-flex">
              {{ detailsInfo.invoiceSerialNum }}
              <span
                class="main-color copy"
                @click="copyClick(detailsInfo.invoiceSerialNum)"
                >复制</span
              >
            </div>
          </div>
          <div class="invoice-row">
            <div class="invoice-row-name">服务费</div>
            <div class="invoice-row-flex">
              <span class="main-color">{{
                detailsInfo.serviceAmount || "--"
              }}</span
              >元
            </div>
          </div>
          <div class="invoice-row">
            <div class="invoice-row-name">电费</div>
            <div class="invoice-row-flex">
              <span class="main-color">{{
                detailsInfo.chargeAmount || "--"
              }}</span
              >元
            </div>
          </div>
          <div class="invoice-row">
            <div class="invoice-row-name">发票金额</div>
            <div class="invoice-row-flex">
              <span class="main-color">{{ detailsInfo.invoiceAccount }}</span
              >元
            </div>
          </div>
          <div class="invoice-row">
            <div class="invoice-row-name">申请时间</div>
            <div class="invoice-row-flex">
              {{ detailsInfo.applyTime }}
            </div>
          </div>
        </div>
      </div>
      <div class="invoice-row row-box">
        <div class="invoice-row-flex">
          <div class="invoice-name">发票订单</div>
          <div class="invoice-name" style="margin-top: 0.12rem" v-if="total">
            一张发票，含{{ total }}笔订单
          </div>
          <!-- <div class="invoice-name-tips">2020/8/1 15:20:21 - 2020/09/1 16:48:23</div> -->
        </div>
        <div class="v-center">
          <router-link
            class="main-color"
            :to="'/open-invoice-order?invoicePkId=' + detailsInfo.invoicePkId"
            >查看</router-link
          >
        </div>
      </div>
      <div class="invoice-details">
        <div class="invoice-details-title">接收信息(必填)</div>
        <div class="invoice-info">
          <div class="invoice-row">
            <div class="invoice-row-name">电子邮箱</div>
            <div class="invoice-row-flex">
              {{ detailsInfo.sendEmail }}
            </div>
          </div>
          <div class="invoice-row">
            <div class="invoice-row-name">手机号</div>
            <div class="invoice-row-flex">
              {{ detailsInfo.phoneNo }}
            </div>
          </div>
          <div class="invoice-row" v-if="detailsInfo.mailingAddress">
            <div class="invoice-row-name">邮寄地址</div>
            <div class="invoice-row-flex">
              {{ detailsInfo.mailingAddress }}
            </div>
          </div>
          <div class="invoice-row" v-if="detailsInfo.expressCompany">
            <div class="invoice-row-name">快递</div>
            <div class="invoice-row-flex">
              {{ detailsInfo.expressCompany }}
            </div>
          </div>
          <div class="invoice-row" v-if="detailsInfo.expressNumber">
            <div class="invoice-row-name">快递单号</div>
            <div class="invoice-row-flex">
              {{ detailsInfo.expressNumber }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="server-phone" @click="openPhone">
      <img src="../../assets/image/customer-service.png" alt="" />
    </div>
    <pi-popup-content ref="popupContent">
      <template v-if="detailsInfo.applyStatus == 3">
        <img
          class="img-url"
          v-if="detailsInfo.invoiceFileUrl"
          :src="detailsInfo.invoiceFileUrl"
          alt=""
        />
      </template>

      <!-- <div class="popup-box">
         <div class="popup-box-title">发票流水号</div>
         <p>{{detailsInfo.invoiceSerialNum ||'--'}} 
           <span class="main-color copy" @click="copyClick(detailsInfo.invoiceSerialNum)">复制</span>
         </p>
       </div> -->
      <div class="popup-box" v-if="detailsInfo.applyStatus == 2">
        <div class="popup-box-title">原因说明</div>
        <p>{{ detailsInfo.remark }}</p>
      </div>
    </pi-popup-content>
  </div>
</template>
<script>
import popupContent from "@/components/pi-popup-content/pi-popup-content.vue";
import {
  invoiceDetails,
  getOperInfo,
  chargeRecodeByInvoice,
} from "../../common/api/index";
import wxJsSdk from "../../common/location";
export default {
  name: "pi-open-invoice-details",
  data() {
    return {
      invoicePkId: "",
      detailsInfo: {},
      operData: {},
      total: 0,
    };
  },
  components: {
    [popupContent.name]: popupContent,
  },
  methods: {
    invoiceDetails() {
      invoiceDetails({ invoicePkId: this.invoicePkId }).then((ret) => {
        if (ret.status === this.$config.ajaxStatus) {
          this.detailsInfo = ret.data[0];
        }
      });
    },
    getStatusInfo() {
      // this.detailsInfo.invoiceFileUrl = "nnfp.jss.com.cn/EYZWi0Wo-in4HVq";
      if (
        this.detailsInfo.applyStatus == 3 &&
        this.detailsInfo.invoiceSerialNum
      ) {
        var value = this.detailsInfo.invoiceFileUrl;
        if (
          (value != "" && value.indexOf("http://") == -1) ||
          (value != "" && value.indexOf("https://") == -1)
        ) {
          value = "https://" + value;
          window.open(value);
        }
        
        // if (process.env.NODE_ENV == "production") {
        //   wxJsSdk.previewImage(
        //     this.detailsInfo.invoiceFileUrl, [this.detailsInfo.invoiceFileUrl], // 需要预览的图片http链接列表
        //   );
        // }else{
        //   this.$refs.popupContent.open();
      }else if(this.detailsInfo.applyStatus == 2){
        this.$refs.popupContent.open();
      }
    },
    getOperInfo() {
      getOperInfo({ oprPkId: this.$oprPkId }).then((data) => {
        if (data.status === this.$config.ajaxStatus) {
          this.operData = data.data[0];
        }
      });
    },
    openPhone() {
      window.location.href = "tel:" + this.operData.tel;
    },
    copyClick(text) {
      this.$common.copyText(text, () => {
        this.$toast("复制成功");
      });
    },
    getInvoiceList() {
      chargeRecodeByInvoice({
        globalPageIndex: 1,
        globalPageSize: 1,
        invoicePkId: this.invoicePkId,
      }).then((ret) => {
        this.total = ret.total;
      });
    },
  },
  mounted() {
    wxJsSdk.reConfig();
    this.getOperInfo();
    this.invoicePkId = this.$route.query.invoicePkId;
    this.invoiceDetails();
    this.$common.bodyAddBg();
    this.getInvoiceList();
  },
  destroyed() {
    this.$common.removeBodyBg();
  },
};
</script>
<style lang="less">
@import url("../open-invoice/css/invoice");
.server-phone {
  position: fixed;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  box-shadow: 0px 0px 19px 0px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  padding: 0.23rem;
  right: 0;
  bottom: 1.5rem;
  box-sizing: border-box;
  img {
    width: 0.54rem;
    height: 0.54rem;
    vertical-align: top;
  }
}
.open-invoice-details {
  .popup-box {
    padding: 0.3rem;
    width: 6rem;
    box-sizing: border-box;
    border-radius: 0.1rem;
    background-color: #fff;
  }
  .img-url {
    width: 6.4rem;
    pointer-events: auto;
  }
  .popup-box-title {
    line-height: 0.32rem;
    text-align: center;
  }
  p {
    margin-top: 0.2rem;
  }
  .copy {
    float: right;
    cursor: pointer;
    padding-left: 0.1rem;
  }
}
</style>